// extracted by mini-css-extract-plugin
module.exports = {"pulse":"ConfirmSection_pulse__M19XC","shockwaveJump":"ConfirmSection_shockwaveJump__Hc1ZD","shockwave":"ConfirmSection_shockwave__DNZES"};